let env;

if (window.settingData.market == "UAE") {
    // UAE config here
    env = {
        STOREFRONT_KEY: "262dbacef9d26e53dfff834b460386d6",
        STOREFRONT_URL: "https://molton-brown-uae.myshopify.com/api/2021-07/graphql.json"
    };
} else {
    env = {
        STOREFRONT_KEY: "f3d3594012b30782e4f35ada7302453a",
        STOREFRONT_URL: "https://molton-brown-ksa.myshopify.com/api/2021-07/graphql.json"
    };
}

export { env };